<p class="title">Recent gebruik</p>
<div class="grafiek-container" *ngIf="(notLoading | async) && data">
  <google-chart class="weekends" [data]="weekendData" (chartReady)="onWeekendReady()"></google-chart>
  <google-chart class="chart" [data]="chartData" (chartReady)="onReady()"></google-chart>
</div>
